import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { Loading } from 'tdesign-react';
import CountUp from 'react-countup';
import { fetchRoleOverview } from '@/slices/kopPermissionsSlice';
import { getCurrentCluster } from '@/pages/Layout/MenuLayout/CulsterAddon';
import SummaryPanel from '@/components/Cluster/SummaryPanel';

function Summary({ overview, fetchRoleOverview, loading, currentCluster }) {
  const [searchParams] = useSearchParams();
  const clusterName = searchParams.get('name');

  useEffect(() => {
    if (clusterName) {
      fetchRoleOverview(clusterName);
    }
  }, [clusterName, fetchRoleOverview]);

  const items = [
    {
      title: 'Enable',
      icon: 'other3',
      info: currentCluster?.clusterAuthType === 'NONE' ? 'No' : 'Yes',
    },
    {
      title: 'ACLs',
      icon: 'producer',
      info: <CountUp end={overview.aclCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Users',
      icon: 'consumer',
      info: <CountUp end={overview.userCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Topics',
      icon: 'subscription',
      info: <CountUp end={overview.topicCount} duration={0.4} />,
      unit: '个',
    },
    {
      title: 'Active Consumer Groups',
      icon: 'other2',
      info: <CountUp end={overview.consumerGroupCount} duration={0.4} />,
      unit: '个',
    },
  ];
  return (
    <Loading loading={loading} size='small'>
      <SummaryPanel shadow items={items} />
    </Loading>
  );
}

export default connect(
  (state) => ({
    overview: state.kopPermissions.overview,
    loading: state.kopPermissions.loading,
    currentCluster: getCurrentCluster(state.kopCluster.allList),
  }),
  {
    fetchRoleOverview,
  },
)(Summary);
